<template>
  <div :class="[bgColor, 'forget-pwd','login-new']">
    <p class="title">{{ $t("forget_password.nav_title") }}</p>
    <p class="sub-title">{{ $t('findPwd.t00003') }}</p>

    <p class="sub-title" v-if="user_no">{{ $t('findPwd.t00004') }}：{{user_no}}
      <span class="btn-copy" v-clipboard:copy="user_no"
            v-clipboard:success="onCopySuccess"></span>
    </p>
    <div class="form">
      <div class="ipt-item">
        <custom-field
          v-model="form.password"
          :formatter="formatter"
          type="password"
          :placeholder="$t('forget_password.password_placeholder')"
          :open-eye-function="true"
          clearable
        >
        </custom-field>
      </div>

      <div class="ipt-item">
        <custom-field
          v-model="form.password_confirmation"
          :formatter="formatter"
          type="password"
          :open-eye-function="true"
          :placeholder="$t('forget_password.confirm_placeholder')"
          clearable
        >
        </custom-field>
      </div>
      <div class="tips-box">
        <p class="item" :class="{active: pwdTips.t1}">
          <span class="icon">
            <van-icon name="success" />
            <span class="in"></span>
          </span>
          {{ $t('findPwd.t00005') }}
        </p>
        <p class="item" :class="{active: pwdTips.t2}">
          <span class="icon">
            <van-icon name="success" />
            <span class="in"></span>
          </span>
          {{ $t('findPwd.t00006') }}
        </p>
        <p class="item" :class="{active: pwdTips.t3}">
          <span class="icon">
            <van-icon name="success" />
            <span class="in"></span>
          </span>
          {{ $t('findPwd.t00007') }}
        </p>
      </div>
      <div class="empty"></div>
      <div class="btn-submit mb0" :class="{dis: isDisabledSubmit}" @click="submit()">{{ $t("common.confirm") }}</div>

    </div>
    <!-- <TelActions></TelActions> -->
    <p class="text">{{ $t('findPwd.t00001') }} <a class="btn" @click="showActionSheet = true">{{ $t('openAccount.t000023') }}</a></p>
    <GlobalActionSheet v-model="showActionSheet"></GlobalActionSheet>
  </div>
</template>

<script>
import customField from "@/components/customField/index.vue";
import TelActions from "./components/TelActions.vue";
import { Button, Icon, Toast } from "vant";
import { login } from "@/utils/hybirdMethods";
import { getBrowser } from "@/utils/browser";
import GlobalActionSheet from "@/components/GlobalActionSheet.vue";

const browser = getBrowser();

export default {
  components: {
    [Button.name]: Button,
    customField: customField,
    [Icon.name]: Icon,
    TelActions,
    GlobalActionSheet
  },
  computed: {
    bgColor(){
      return this.$store.getters["common/bgColor"];
    },
    isDisabledSubmit() {
      return !(this.pwdTips.t1 && this.pwdTips.t2 && this.pwdTips.t3);
    },
    pwdTips(){
      return {
        t1: this.form.password.length >= 8,
        t2: this.regexValidatePassword(this.form.password),
        t3: this.form.password && this.form.password == this.form.password_confirmation,
      };
    }
  },
  data(){
    return {
      user_no: '',
      form: {
        password: '',
        password_confirmation: ''
      },
      showActionSheet: false
    }
  },
  created(){
    this.sign = this.$route.query.sign;
    this.user_no = this.$route.query.user_no;
  },
  methods:{
    onCopySuccess(){
      Toast(this.$t("transferIntoAbroad.lang11"));
    },
    formatter(value) {
      return value.replace(/ /g, "");
    },
    regexValidatePassword(password) {
      const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d).{8,}$/;

      return passwordRegex.test(password);
    },
    submit(){
      if(this.isDisabledSubmit){
        return;
      }
      if(!this.regexValidatePassword(this.form.password)){
        return Toast(this.$t("forget_password.tips3"));
      }

      if (this.form.password !== this.form.password_confirmation) {
        return this.$toast.fail(this.$t("forget_password.tips1"));
      }
      const params = {
        sign: this.sign,
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
      };
      this.$apis.resetPassword3Api(params).then(res=>{
        if ( !res.code ) {
          Toast(this.$t("forget_password.tips2"));
          const { token, user_info } = res;
          this.$localstorage.set("userInfo", user_info);
          sessionStorage.setItem("token", token);
          if (browser.isGetProApp) {
            this.$router.push({
              path: "/mode-select"
            });
          } else if (browser.isApp) {
            res.type = true;
            login(res);
          } else {
            this.$router.push("/");
          }
        }
      })
    }
  }
}
</script>


<style scoped lang="less">
@import "../login-new/components/form.comon.less";
.tips-box{
  margin-top: 40px;
  .item{
    line-height: 40px;
    display: flex;
    .icon{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      .in{
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #444;
      }
      .van-icon{
        display: none;
      }
    }
    &.active{
      color: #009a61;
      .icon{
        .van-icon{
          display: block;
        }
        .in{
          display: none;
        }
      }
    }
  }
}
.sub-title{
  display: flex;
  align-items: center;
}
.btn-copy{
  margin-left: 15px;
  margin-bottom: 5px;
  width: 35px;
  height: 35px;
  background: url("../../assets/images/copy.png") no-repeat;
  background-size: 100% 100%;
}
.black-theme{
  .tips-box{
    .item{
      .icon{
        .in{
          background: #fff;
        }
      }
    }
  }
  .btn-copy{
    background: url("../../assets/images/copy-2.png") no-repeat;
    background-size: 100% 100%;
  }
}
.text{
  text-align: center;
  margin-top: 20px;
  a{
    color: #328CF4;
  }
}
</style>